webpackJsonp([101587228563537],{

/***/ 932:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0025_centaur.jpg","type":"Unit","subtype":"Centaur","cost":3,"ATK":3,"HP":4,"rules_text_1":"Overpower (Excess combat damage this would deal to a patroller hits something else this could attack.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Centaur","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Green","spec":"Feral","bottom":"Tech I","rulings":[],"keywords":["Overpower"],"slug":"centaur"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"centaur","keywords":["Overpower"],"imageRegex":"/centaur.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-centaur-302791500c855569ab9a.js